module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-photo-01148a4cdee12e62825e2f8099fc4cfc.jpg";